import { Helmet as Head } from 'react-helmet';
import styled from 'styled-components';

import ResetPassword from '../../components/authentication/resetPassword';
import { useResponsive } from '../../hooks/use-responsive';

const PasswordRecovery = () => {
  const { isMobile, isTablet, isPortrait } = useResponsive();

  return (
    <>
      <Head>
        <title>Password Recovery | Material Kit Pro</title>
      </Head>
      {isMobile || (isPortrait && isTablet) ? (
        <ResetPasswordMobileWrap>
          <ResetPassword />
        </ResetPasswordMobileWrap>
      ) : (
        <ResetPasswordWrap>
          <ResetPassword />
        </ResetPasswordWrap>
      )}
    </>
  );
};

export default PasswordRecovery;

const ResetPasswordWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 50%;
  overflow: hidden;
  position: relative;
`;

const ResetPasswordMobileWrap = styled(ResetPasswordWrap)`
  width: 100%;
`;
